import { hasValue } from "./has-value";
import { isEmail } from "./is-email";
import { isURL } from "./is-url";
import { isEqual } from "./is-equal";
import { isNotEqual } from "./is-not-equal";
import { selectValue } from "./select-value";
import { isNumber } from "./is-number";
import { isStringEmptyOrUndefined } from "./is-string-emptyOrUndefined";

export const Validators = {
  hasValue,
  isEmail,
  isURL,
  isEqual,
  isNotEqual,
  selectValue,
  isNumber,
  isStringEmptyOrUndefined,
};
